// extracted by mini-css-extract-plugin
module.exports = {"followUs":"style_followUs__vH__n","icon":"style_icon__WtE6N","followList":"style_followList__LwuSJ"};